@if (slides) {
  <div class="main-slider">
    <swiper-container class="h-100" [sale4AllSwiper]="config" init="false" dir="rtl">
      @for (slide of slides; track slide) {
        <swiper-slide>
          <div [style.background-image]="'url(' + slide.image + ')'" class="slide-item">
            <div class="mask"></div>
            <div fxLayout="column" fxLayoutAlign="center center" class="content">
              <h1>{{slide.title}}</h1>
              <h3>{{slide.subtitle}}</h3>
              <button mat-raised-button color="primary">{{'sale4you.slider.shopNow' | translate }}</button>
            </div>
          </div>
        </swiper-slide>
      }
      <div class="swiper-pagination white"></div>
      <button aria-label="הקודם" mat-mini-fab color="primary" class="swiper-button-prev swipe-arrow"><mat-icon>keyboard_arrow_left</mat-icon></button>
      <button aria-label="הבא" mat-mini-fab color="primary" class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
    </swiper-container>
  </div>
}
